import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/loading.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = { class: "mt-2 py-6 flex flex-col justify-center items-center" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-6 w-full" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Title", -1)
const _hoisted_8 = { class: "block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Description", -1)
const _hoisted_10 = { class: "block" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Instagram", -1)
const _hoisted_12 = { class: "block" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Youtube", -1)
const _hoisted_14 = { class: "block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Image", -1)
const _hoisted_16 = {
  key: 0,
  class: "flex flex-row justify-evenly"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "flex flex-row justify-evenly"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-12 h-12",
  src: _imports_0
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]

import axios from "axios";
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {ref} from "vue";
import Api from "@/utils/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'EditHomePageDialog',
  props: {
    onClose: { type: Function },
    homeData: {}
  },
  setup(__props: any) {

const loading = ref(false)
const title = ref('')
const description = ref('')
const image = ref<any>(null)
const instagram = ref('')
const youtube = ref('')

const props = __props;

const isEdit = ref(props.homeData !== null)

const closeDialog = () => {
  props.onClose?.()
}

if(props.homeData !== null) {
  title.value = props.homeData?.title ?? ""
  description.value = props.homeData?.description ?? ""
  instagram.value = props.homeData?.instagram ?? ""
  youtube.value = props.homeData?.youtube ?? ""
}

const postData = async () => {
  // as multipart formadata
  loading.value = true
  const data = new FormData()
  data.append('title', title.value)
  data.append('description', description.value)
  if(image.value !== null) {
    data.append('image', image.value)
  }
  data.append('instagram', instagram.value)
  data.append('youtube', youtube.value)
  if(isEdit.value) {
    data.append('isEdit', isEdit.value.toString())
  }

  try {
    await axios.post(Api.UPDATE_HOME_PAGE, data)
    alert('Home page data updated')
    closeDialog();
  } catch (e) {
    alert('Failed to update home page data')
    console.error(e)
  } finally {
    loading.value = false
  }
}

const handleImageChange = (e: any) => {
  const target = e.target as HTMLInputElement;
  if (target && target.files) {
    image.value = target.files[0];
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: true
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: closeDialog
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "w-full max-w-md transform overflow-hidden rounded-2xl bg-brand-card p-6 text-left align-middle shadow-xl transition-all" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg font-medium leading-6 text-center text-brand-text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Edit Home Page Data ")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("label", _hoisted_6, [
                            _hoisted_7,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                              type: "text",
                              class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, title.value]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_8, [
                            _hoisted_9,
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                              class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
                              rows: "3"
                            }, null, 512), [
                              [_vModelText, description.value]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_10, [
                            _hoisted_11,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((instagram).value = $event)),
                              type: "text",
                              class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, instagram.value]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_12, [
                            _hoisted_13,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((youtube).value = $event)),
                              type: "text",
                              class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, youtube.value]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("input", {
                              onChange: handleImageChange,
                              type: "file",
                              accept: "image/*",
                              class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
                              placeholder: "john@example.com"
                            }, null, 32)
                          ]),
                          (!loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("button", {
                                  onClick: postData,
                                  class: "bg-brand-secondary justify-center w-32 text-center text-white font-bold space-x-2 px-6 py-2 rounded-md flex flex-row"
                                }, _hoisted_18),
                                _createElementVNode("button", {
                                  onClick: closeDialog,
                                  class: "bg-red-500 justify-center w-32 text-center text-white font-bold space-x-2 px-6 py-2 rounded-md flex flex-row"
                                }, _hoisted_20)
                              ]))
                            : _createCommentVNode("", true),
                          (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})